import React, { useState } from 'react'
import { DetailActionsWrapper } from './styled'
import NFTShareModal from '../NFTShareModal'
import { INFTDetailActionsProps } from './INFTDetailActionsModel'

export default function NFTDetailActions({ creator, seller, tokenPrice }: INFTDetailActionsProps) {
  const [shareModalShow, setShareModalShow] = useState(false)

  function getReportText() {
    return `https://docs.google.com/forms/d/e/1FAIpQLSf6zpSguqestqBzEKvCXA-i8MV6sqMIN0xAnhuF07Ndu6dfdA/viewform?usp=pp_url&entry.1417031964=${window.location.href.replace(
      '/#/',
      '/%23/'
    )}`
  }

  function getShareText() {
    const shareText = 'Look what i {text} on @YetiSwap #NFT #Marketplace...'
    let text = ''

    if (creator === 'wallet' && tokenPrice === '0') {
      text = 'create'
    } else if (seller === 'wallet' && tokenPrice !== '0') {
      text = 'sell'
    } else {
      text = 'found'
    }

    return shareText.replace('{text}', text)
  }

  function showShareModal() {
    setShareModalShow(true)
  }
  function shareModalDismiss() {
    setShareModalShow(false)
  }
  return (
    <>
      <DetailActionsWrapper>
        <div className="detail-action-open" />
        <div className="detail-actions-buttons">
          <ul>
            <li onClick={showShareModal}>
              <span>Share</span>
            </li>
            <li>
              <a href={getReportText()} target="_blank" rel="noopener noreferrer">
                Report
              </a>
            </li>
          </ul>
        </div>
      </DetailActionsWrapper>
      <NFTShareModal isOpen={shareModalShow} onDismiss={shareModalDismiss} shareText={getShareText()} />
    </>
  )
}
